
import React, { useState, useEffect } from 'react';
import { Checkbox, Row, Col } from 'antd';
import Input from 'components/Form/Input';
import styled from 'styled-components';

const FilterContainer = styled.div`
display: flex;
flex-direction: row;
  position: relative;
  /* padding: 16px; */
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px;
  width: 50%
`;

const InputWrapper = styled.div`
  position: absolute;
  top: 10vh;
  display: flex;
  width: 90%;
  gap: 1vh;
`;

const InputColumn = styled.div`
  width: 50%;
`;

const Label = styled.div`
  font-size: 14px;
  color: #4D566E;
  margin-bottom: 8px;
`;

const ErrorText = styled.div`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 4px;
`;

const ArrearsFilter = ({ filterValues = {}, setFilterValues }) => {
  const [pastComparisonType, setPastComparisonType] = useState('');
  console.log(pastComparisonType,'pastComparisonType')
  const [currentComparisonType, setCurrentComparisonType] = useState('');
  console.log(currentComparisonType,'currentComparisonType')
  const [errors, setErrors] = useState({ past: '', current: '' });
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (filterValues.selectedPastArrearFilterType === 'GTE') {
      setPastComparisonType('greaterThan');
    } else if (filterValues.selectedPastArrearFilterType === 'LTE') {
      setPastComparisonType('lessThan');
    } else {
      setPastComparisonType('');
    }

    if (filterValues.selectedCurrentArrearFilterType === 'GTE') {
      setCurrentComparisonType('greaterThan');
    } else if (filterValues.selectedCurrentArrearFilterType === 'LTE') {
      setCurrentComparisonType('lessThan');
    } else {
      setCurrentComparisonType('');
    }

    setShow(!filterValues.includeArrears);
  }, [filterValues.selectedPastArrearFilterType, filterValues.selectedCurrentArrearFilterType, filterValues.includeArrears]);

  const handleComparisonChange = (type, value) => {
    const isSame = (type === 'past' ? pastComparisonType : currentComparisonType) === value;
    const newValue = isSame ? '' : value;
    console.log(newValue,'newValue')

  
    if (type === 'past') {
      setPastComparisonType(newValue);
    
      setFilterValues(prev => ({
        ...prev,
        selectedPastArrearFilterType: newValue === 'greaterThan' ? 'GTE' : newValue === 'lessThan' ? 'LTE' : '',
        ...(newValue === '' && { selectedPastArrearCount: '' }) // Clear arrear count if deselected
      }));
    
      setErrors(prev => ({ ...prev, past: '' }));
    } else {
      setCurrentComparisonType(newValue);
    
      setFilterValues(prev => ({
        ...prev,
        selectedCurrentArrearFilterType: newValue === 'greaterThan' ? 'GTE' : newValue === 'lessThan' ? 'LTE' : '',
        ...(newValue === '' && { selectedCurrentArrearCount: '' }) // Clear arrear count if deselected
      }));
      setErrors((prev) => ({ ...prev, current: '' }));
    }
  };

  const handleInputChange = (field, value) => {
    const numericValue = value.replace(/\D/g, ''); // Remove non-numeric characters
    const numericValueLimited = numericValue.slice(0, 2);
    const hasSelection =
      (field === 'past' && pastComparisonType?.length > 0) ||
      (field === 'current' && currentComparisonType?.length > 0);

    setErrors((prev) => ({
      ...prev,
      [field]: hasSelection ? '' : 'Please select at least one option.',
    }));

    if (hasSelection && (field === 'past' || field === 'current')) {
      setFilterValues(prev => ({
        ...prev,
        [`selected${field.charAt(0).toUpperCase() + field.slice(1)}ArrearCount`]: numericValueLimited,
      }));
    }
  };

  

  return (
    <>
  
      {show && (
        <FilterContainer >
          
            <CheckboxContainer>
              <Checkbox
                checked={pastComparisonType === 'lessThan'}
                onChange={() => handleComparisonChange('past', 'lessThan')}
               
              >
                ≤ Lesser than or Equal to
              </Checkbox>
              <Checkbox
                checked={pastComparisonType === 'greaterThan'}
                onChange={() => handleComparisonChange('past', 'greaterThan')}
                style={{marginLeft:0 }}
              >
                ≥ Greater than or Equal to
              </Checkbox>
            </CheckboxContainer>
        
            <CheckboxContainer>
              <Checkbox
                checked={currentComparisonType === 'lessThan'}
                onChange={() => handleComparisonChange('current', 'lessThan')}
               
              >
                ≤ Lesser than or Equal to
              </Checkbox>
              <Checkbox
                checked={currentComparisonType === 'greaterThan'}
                onChange={() => handleComparisonChange('current', 'greaterThan')}
                style={{marginLeft: 0}}
              >
                ≥ Greater than or Equal to
              </Checkbox>
            </CheckboxContainer>
        
        </FilterContainer>
      )}
      <InputWrapper>
        <InputColumn>
          <Label>History Of Arrears</Label>
          <Input
          width="100%"
            value={filterValues.selectedPastArrearCount || ''}
            placeholder="Enter Past Arrears"
            onChange={(e) => handleInputChange('past', e.target.value)}
            maxLength={2}
            inputMode="numeric"
            pattern="[0-9]*"
          />
          {errors.past && <ErrorText>{errors.past}</ErrorText>}
        </InputColumn>
        <InputColumn>
          <Label>Current Arrears</Label>
          <Input
          width="100%"
            value={filterValues.selectedCurrentArrearCount || ''}
            placeholder="Enter Current Arrears"
            onChange={(e) => handleInputChange('current', e.target.value)}
            maxLength={2}
            inputMode="numeric"
            pattern="[0-9]*"
          />
          {errors.current && <ErrorText>{errors.current}</ErrorText>}
        </InputColumn>
      </InputWrapper>
    
    
      <Checkbox
        checked={filterValues.includeArrears}
        onChange={(e) => {
          setFilterValues({
            ...filterValues,
            selectedCurrentArrearCount:null,
            selectedCurrentArrearFilterType:'',
            selectedPastArrearCount:null,
            selectedPastArrearFilterType:'',
            includeArrears: e.target.checked,
          });
          setPastComparisonType('');
          setCurrentComparisonType('');
          setShow(!e.target.checked);
          setErrors({ past: '', current: '' })
        }}
        style={{position: 'absolute',top: '25vh'}}
      >
        Show no arrears candidates
      </Checkbox>
      </>
  );
};

export default ArrearsFilter;